<template>
  <div>
    <v-layout
      wrap
      justify-center
      fill-height
      class="select-page"
      style="position: relative; margin-bottom: 35px"
      :class="{ 'no-bot': !botlist || botlist.length == 0 }"
    >
      <template v-for="bot in botlist">
        <AccountItem :key="'bot_' + bot.pageid" :bot="bot"></AccountItem>
      </template>
    </v-layout>
    <v-btn
      v-if="botlist && botlist.length >= itemPerPage"
      :loading="loading"
      :disabled="loading"
      x-large
      block
      outline
      color="black"
      @click="getMore"
      >MORE</v-btn
    >
  </div>
</template>

<script>
import api from '@/api'
import AccountItem from './AccountItem.vue'
export default {
  components: {
    AccountItem
  },
  props: ['dirtySearch', 'itemPerPage'],
  data() {
    return {
      botlist: [],
      offset: 0,
      loading: false
    }
  },
  watch: {
    dirtySearch() {
      this.onSearch()
    }
  },
  mounted() {
    let vm = this
    vm.getMore()
  },
  methods: {
    async onSearch() {
      let vm = this
      vm.botlist = []
      vm.offset = 0
      vm.loading = true
      await vm.getMore()
    },
    async getMore(options = {}) {
      // use only for zwizadmin
      let vm = this
      let data = {
        limit: this.itemPerPage,
        offset: vm.offset,
        pagename: vm.dirtySearch ? vm.dirtySearch.toLowerCase() : undefined,
        ...options
      }
      vm.loading = true
      try {
        const response = await vm.getAccounts(data)
        vm.loading = false

        vm.botlist.push(...response.botlist)
        vm.$store.commit('SET_BOTLIST', vm.botlist)
        vm.offset += vm.itemPerPage
      } catch (error) {
        console.error(error)
      }
    },
    getAccounts(data) {
      return new Promise((resolve, reject) => {
        api.zwizadminbotlist(data, (err, response) => {
          if (err) return reject(err)
          return resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AccountForZwizAdmin.vue